module.exports = "<span class=\"c-tree__item js-tree__item\"></span>\r\n<span class=\"c-tree__item-subtree\"></span>\r\n";